import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import {MeshoptDecoder} from "meshoptimizer";
import * as THREE from "three";

class Demo {
  static createDemoModel(name, path, callback) {
    let loader = new GLTFLoader();
    loader.setMeshoptDecoder(MeshoptDecoder);
    loader.load(path, gltf => {
      let box = new THREE.Box3().setFromObject(gltf.scene);
      box.getCenter(gltf.scene.position);
      gltf.scene.position.multiplyScalar(-1);

      let model = new THREE.Group();
      let obj = gltf.scene;
      model.add(obj);

      obj.traverse(child => {
        if (child.type === "Mesh" || child.isMesh) {
          child.castShadow = true;
          child.material.metalness = 0.2;
          child.material.format = THREE.RGBAFormat;
          // for Draggable Tree
          child.key = child.uuid;
          child.title = child.name;
        }
      });

      model.traverse(child => {
        child.layers.set(1);
      });
      model.name = name;
      model.userData.friction = 1;
      model.userData.mass = 20;
      model.userData.canCollide = false;
      model.userData.isKinematic = true;
      model.userData.demo = true;
      model.userData.type = "asset";
      model.userData.path = path;
      model.userData.opacity = 1;
      // Temporal config
      model.userData.bodyType = "box";

      model.userData.width = box.max.x - box.min.x;
      model.userData.height = box.max.y - box.min.y;
      model.userData.depth = box.max.z - box.min.z;

      model.position.set(0, (box.max.y - box.min.y) / 2, 0);

      callback(model);
    });
  }
}
export default Demo;
